import React from "react";

const CategorySkeleton = () => {
  return (
    <>
      <div className="menu__categories-item skeleton__categories"></div>
      <div className="menu__categories-item skeleton__categories"></div>
      <div className="menu__categories-item skeleton__categories"></div>
      <div className="menu__categories-item skeleton__categories"></div>
      <div className="menu__categories-item skeleton__categories"></div>
      <div className="menu__categories-item skeleton__categories"></div>
      <div className="menu__categories-item skeleton__categories"></div>
      <div className="menu__categories-item skeleton__categories"></div>
    </>
  );
};

export default CategorySkeleton;
